

import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import GroupAdminHeader from "../../Comman/Header";
import GroupAdminSidebar from "../../Comman/Sidebar";
import useDrawer from "../../../context/DrawerContext";
import { submitForm } from "../../Comman/AddCommonFun/AddCommonFunction";
import { passwordValidation, validateEmail } from "../../Comman/AddCommonFun/validation";
import useError from "../../Comman/Error/useError";
import { ErrorMessage } from "../../Comman/Error/ErrorMessage";
import { applyFilterMeHandlers } from "../../Comman/Error/jqueryUtils";
import { SubmitformButton } from "../../Comman/Error/SubmitformButton";
import { HeaderSection } from "../../Comman/Error/HeaderSection";

const FormField = ({ field, value, handleChange }) => (
  <div className="col-md-6 mb-10">
    <label className="required form-label">{field.label}</label>
    <input
      type={field.type}
      className={field.className}
      placeholder={field.placeholder}
      name={field.name}
      value={value}
      onChange={handleChange}
      maxLength={field?.maxLength}
      minLength={field?.minLength}
      required
    />
  </div>
);

export default function GroupAdminAddWaiter() {
  useEffect(() => {
    applyFilterMeHandlers(); // Apply the jQuery handlers
  }, []);

  const { error, showError, clearError } = useError();
  const history = useHistory();
  const { id } = useParams();

  const formFields = [
    { name: 'name',type: 'text',  placeholder: 'Service Staff Name', label: 'Service Staff Name', className: "form-control form-control-solid" },
    { name: 'phone_number', type: 'text', placeholder: 'Phone Number', label: 'Phone Number', className: "form-control form-control-solid filterme" },
    { name: 'staff_id', type: 'text',maxLength:"4" , minLength:"4", placeholder: 'Staff Id', label: 'Staff Id', className: "form-control form-control-solid filterme" },
    { name: 'pin', type: 'text',maxLength:"4" , minLength:"4", placeholder: 'Pin Code', label: 'Pin Code', className: "form-control form-control-solid filterme" },
  ];

  const [formValues, setFormValues] = useState({
    name: '',
    phone_number: '',
    pin: '',
    staff_id: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    clearError(null);

    if (formValues.name.trim().length < 3) {
      showError("Service staff name must be at least 3 characters long");
      return;
    }

    const newWaiter = {
      branch_id: id,
      name: formValues.name,
      pin: formValues.pin,
      phone_number: formValues.phone_number,
      staff_id: formValues.staff_id,
    };

    submitForm("/groupadmin/waiter", newWaiter, history, showError, clearError, "Service Staff has been added successfully.");
  };

  useEffect(() => {
    const list = "0123456789";
    var res = "";
    for (var i = 0; i < 4; i++) {
      var rnd = Math.floor(Math.random() * list.length);
      res = res + list.charAt(rnd);
    }
    setFormValues((prevValues) => ({
      ...prevValues,
      "staff_id" : res,
    }));
}, []);

      const { drawerPos, handleDrawer, maingetViewDetails } = useDrawer();

  return (
    <React.Fragment>
      <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed">
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
            <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
              <GroupAdminHeader />
              <div className="d-flex flex-column flex-column-fluid" id="kt_content">
                <div id="kt_content_container" className="mx-7">
                  <main className={`main_ ${maingetViewDetails.join(" ")}`}>
                  <HeaderSection title="Add Service Staff" goBackHandler={() => history.goBack()} />
                    <div className="py-5">
                      <div className="card card-docs mb-2">
                        <div className="card-body fs-6 py-15 px-10 py-lg-15 px-lg-15 text-gray-700">
                          <div className="rounded border p-10">
                            <form onSubmit={handleSubmit}>
                              <div className="row col-md-12">
                                {formFields.map((field, index) => (
                                  <FormField
                                    key={index}
                                    field={field}
                                    value={formValues[field.name]}
                                    handleChange={handleChange}
                                  />
                                ))}
                              </div>
                              <ErrorMessage error={error} />
                             <SubmitformButton handleSubmit={handleSubmit} onCancel={() => history.goBack()} />
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </main>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

